import { connect } from 'react-redux'
import EventSetupDivisions from '../../components/content/event_setup_divisions'
import {
  saveEventSettingsWidget,
  deleteDivisions,
  getMatchingMembersDivision,
  toggleAutorefillDivisionset,
  refillDivisionset,
  setGenericData,
  pollJob,
  pollUpdateNotifyMessages,
  reloadWidgetContent,
} from '../../actions/index'
import moment from 'moment'
import { showNotification, showErrorNotification } from 'Shared/helpers'
import React from 'react'

const asHTML = v => <div dangerouslySetInnerHTML={{ __html: v }} />

// const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeDivision: (divisionId) => {
    const links = ownProps.content.links
    const oldDivisions = ownProps.content.divisions_without_divisionset
    const divisions = ownProps.content.divisions_without_divisionset.filter(division => division.id !== divisionId)
    dispatch(setGenericData(ownProps.widgetId, [ 'divisions_without_divisionset' ], divisions))
    if (!ownProps.content.dataChanged) {
      dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], true))
    }
    dispatch(deleteDivisions(ownProps.widgetId, links.delete_divisions.path, { object_id: divisionId }))
      .catch(() => {
        dispatch(setGenericData(ownProps.widgetId, [ 'divisions_without_divisionset' ], oldDivisions))
        dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], false))
      })
  },
  updateDivisionRow: (rowId, updatedFieldsDivision) => {
    const divisions = ownProps.content.create_division.multiple_criteria_divisions || []
    dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'multiple_criteria_divisions' ], {
      ...divisions,
      [rowId]: { ...divisions[rowId], ...updatedFieldsDivision },
    }))
  },
  editDivisionset: (divisionsetId) => {
    const divisionset = ownProps.content.divisionsets[divisionsetId]
    if (divisionset) {
      const options = divisionset.division_options
      if (divisionset.order_type === 'auto_by_multiple_criteria') {
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'multiple_criteria_divisions' ], options.divisions || {}))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'autofill_options', 'selected' ], divisionset.auto_refill_options.value.toString()))
      } else if (divisionset.order_type === 'auto_division') {
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'custom_fields', 'selected' ], options.custom_field_id))
      } else {
        const settings = divisionset.handicap_divisions_settings
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'divisions' ], options.divisions || {}))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'selected' ], settings.group_type))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'maximum_handicap', 'selected' ], settings.maximum_handicap))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'same_index', 'selected' ], settings.same_index))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'auto_fill', 'selected' ], divisionset.auto_refill_options.value))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'choices', 'number_of_divisions', 'value' ], settings.number_of_divisions))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'golfers_divisions', 'choices', 'number_of_golfers', 'value' ], settings.number_of_golfers))
      }
      if (options.playing_handicap_settings) {
        const settings = options.playing_handicap_settings
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'tee_and_hole' ], settings.tee_and_hole))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'adjustment_handicap' ], settings.adjustment_handicap))
        dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'gender_adjustment_handicap' ], settings.gender_adjustment_handicap))
      }
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'criteria', 'selected' ], options.criteria.selected))
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'criteria', 'selected_handicap' ], options.criteria.selected_handicap))
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'date_for_age' ], options.date_for_age))
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'date_for_autofill' ], options.date_for_autofill))
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'autofill_options', 'selected' ], divisionset.auto_refill_options.value?.toString()))
      dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'first_round_hi_options', 'selected' ], divisionset.use_first_round_hi?.toString()))
      dispatch(setGenericData(ownProps.widgetId, [ 'editingDivision' ], true))
      dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], true))
      dispatch(setGenericData(ownProps.widgetId, [ 'divisionset_id' ], divisionsetId))
    }
  },
  getMatchingMembers: (fields) => {
    const links = ownProps.content.links
    const divisionsetId = ownProps.content.divisionset_id
    return dispatch(getMatchingMembersDivision(links.get_matching_members_division.path, { ...fields, divisionset_id: divisionsetId }))
  },
  toggleAutorefill: async (divisionsetId) => {
    const links = ownProps.content.links
    const value = ownProps.content.divisionsets[divisionsetId].auto_refill_options.value
    dispatch(setGenericData(ownProps.widgetId, [ 'divisionsets', divisionsetId, 'auto_refill_options', 'value' ], !value))
    await dispatch(toggleAutorefillDivisionset(links.toggle_autofill.path, { divisionset_id: divisionsetId }))
    dispatch(ownProps.refresh)
  },
  refillDivisionset: (divisionsetId) => {
    const links = ownProps.content.links
    dispatch(refillDivisionset(links.refill_divisionset.path, { 
      divisionset_id: divisionsetId,
      source: 'dashboard',
    }))
      .then((response) => {
        if (response.message) {
          response.message && showNotification(asHTML(response.message))
        }
        dispatch(ownProps.refresh)
        dispatch(reloadWidgetContent('event_setup_divisions'))
        if ('job_id' in response) {
          pollJob(response.job_id, update => pollUpdateNotifyMessages(update, asHTML))
            .catch((update) => {
              const message = update?.value?.errors?.join('\n') || (!window.I18n ? '' : window.I18n.t('dashboard_plus.widgets.refill_error'))
              showErrorNotification(asHTML(message))
            })
            .finally(() => {
              dispatch(ownProps.refresh)
              dispatch(reloadWidgetContent('event_setup_flights'))
            })
        }
      })
  },
  removeDivisionset: (divisionsetId) => {
    const links = ownProps.content.links
    const oldDivisionsets = ownProps.content.divisionsets
    const divisionsets = ownProps.content.divisionsets
    delete divisionsets[divisionsetId]
    dispatch(setGenericData(ownProps.widgetId, [ 'divisionsets' ], divisionsets))
    if (!ownProps.content.dataChanged) {
      dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], true))
    }
    dispatch(deleteDivisions(ownProps.widgetId, links.delete_divisionsets.path, { object_id: divisionsetId }))
      .catch(() => {
        dispatch(setGenericData(ownProps.widgetId, [ 'divisionsets' ], oldDivisionsets))
        dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], false))
      })
      
  },
  setData: (keys, value) => {
    dispatch(setGenericData(ownProps.widgetId, keys, value))
    if (!ownProps.content.dataChanged) {
      dispatch(setGenericData(ownProps.widgetId, [ 'dataChanged' ], true))
    }
  },
  save: () => {
    const links = ownProps.content.links
    const createDivision = ownProps.content.create_division

    let multipleCriteriaDivisions = {}
    if (ownProps.content.create_division.multiple_criteria_divisions) {
      const hash = ownProps.content.create_division.multiple_criteria_divisions
      multipleCriteriaDivisions = Object.fromEntries(
        Object.entries(hash).map(([ id, value ]) => {
          const { memberIds, ...rest } = value
          return [ id, rest ]
        }),
      )
    }
    const requestData = {
      source: ownProps.content.editingDivision ? 'edit' : 'add_division',
      divisionset_id: ownProps.content.divisionset_id,
      division_name: createDivision.single_division?.division_name,
      division_source: createDivision.division_source,
      copy_division_id: createDivision.copy_division_id,
      copy_division_round_id: createDivision.rounds.selected,
      criteria: createDivision.criteria.selected,
      handicap: createDivision.criteria.selected_handicap,
      divisions: createDivision.divisions,
      with_tees: !!createDivision.tees,
      tee_and_hole: createDivision?.tee_and_hole,
      adjustment_handicap: createDivision?.adjustment_handicap,
      gender_adjustment_handicap: createDivision?.gender_adjustment_handicap,
      custom_field: createDivision.custom_fields?.selected,
      anchor_date: moment.unix(createDivision.date_for_age).format('DD-MM-Y'),
      autofill_date: createDivision.date_for_autofill ? moment.unix(createDivision.date_for_autofill).format() : null,
      divisions_by_course: {
        round: createDivision.rounds.selected,
        courses: createDivision.divisions_by_course,
      },
      golfers_divisions: {
        by: createDivision.golfers_divisions.selected,
        auto_fill: createDivision.golfers_divisions.selected === 'number_of_divisions' && createDivision.golfers_divisions.auto_fill.selected,
        count: createDivision.golfers_divisions.choices[createDivision.golfers_divisions.selected]?.value,
        maximum_index: createDivision.golfers_divisions.maximum_handicap.selected,
        same_index: createDivision.golfers_divisions.same_index.selected,
      },
      auto_refill: createDivision.autofill_options.selected,
      use_first_round_hi: createDivision.first_round_hi_options.selected,
      multiple_criteria_divisions: multipleCriteriaDivisions,
    }

    dispatch(saveEventSettingsWidget(ownProps.widgetId, links.save.path, { create_divisions: requestData }, { withNotifications: false }))
      .then(({ response }) => {
        response.message && showNotification(asHTML(response.message))
        response.errors && showErrorNotification(asHTML(response.errors))
        dispatch(ownProps.refresh)
        dispatch(reloadWidgetContent('event_setup_flights'))

        if ('job_id' in response) {
          pollJob(response.job_id, update => pollUpdateNotifyMessages(update, asHTML))
            .catch((update) => {
              const message = update?.value?.errors?.join('\n') || (!window.I18n ? '' : window.I18n.t('dashboard_plus.widgets.save_settings_error'))
              showErrorNotification(asHTML(message))
            })
            .finally(() => {
              dispatch(ownProps.refresh)
              dispatch(reloadWidgetContent('event_setup_flights'))
            })
        }
      })
      .finally(() => {
        dispatch(setGenericData(ownProps.widgetId, [ 'addingDivision' ], false))
      })
  },
  setError: (key, val) => {
    dispatch(setGenericData(ownProps.widgetId, [ 'create_division', 'errors', key ], val))
  },
  closeModal: () => {
    dispatch(setGenericData(ownProps.widgetId, [ 'modal_opened' ], false))
  },
})

export default connect(
  null,
  mapDispatchToProps,
)(EventSetupDivisions)
